import { Environment } from 'shared';

const getLocale = (path: string) => {
  const localePattern = /^\/([a-z]{2}-[a-z]{2})\//;
  const match = path.match(localePattern);

  return match?.[1];
};

export const getMMBRoute = (environment: Environment, MMB_PATH: string) => {
  const { origin, pathname } = location;
  const locale = getLocale(pathname);
  const host = environment === 'development' ? 'https://test.sas.se' : origin;

  return [host, locale, MMB_PATH].filter(Boolean).join('/');
};

export const isLocalhost = () => {
  const hostname = window.location.hostname;
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname.endsWith('.local');
};

export const getMarketFromPathname = () => {
  const match = location.pathname.match(/\/([a-z]{2}-[a-z]{2})\//i);

  if (match && match.length > 1) {
    return match[1];
  }

  return location.pathname.startsWith('/en/') ? 'en' : undefined;
};

export const prependMarketToPath = (path: string) => {
  const pathnameMarket = getMarketFromPathname();
  return pathnameMarket ? `/${pathnameMarket}${path}` : path;
};
